import TextSliderBase from "../../abstracts/textSliderBase";
import textSlider from "../template";
import contentsHistory from "./textContents";

export default class HistorySlideText extends TextSliderBase {
    private static idSlide = "history-text-slide";
    private static elementToRender = textSlider(HistorySlideText.idSlide);
    private static arrayContents = contentsHistory

    constructor(protected parentElement:HTMLElement){
        super(
            HistorySlideText.idSlide,
            parentElement,
            HistorySlideText.arrayContents[localStorage.getItem("i18n")],
            HistorySlideText.elementToRender
        );
    }
}